export default {
    props: {
        animationCloseEffects: {
            type: String,
            kComposite: 'animation.close.effects'
        }, 
        animationCloseDuration: {
            type: Number,
            kComposite: 'animation.close.duration'
        }, 
        animationOpenEffects: {
            type: String,
            kComposite: 'animation.open.effects'
        }, 
        animationOpenDuration: {
            type: Number,
            kComposite: 'animation.open.duration'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/Common/Animation.js